import {
  LOAD_UPLOADED_FILES,
  LOAD_UPLOADED_DETAILS_SUCCEEDED,
  LOAD_UPLOADED_DETAILS_FAILED,
  LIST_SELECTED,
  START_BULK_VALIDATION,
  DOWNLOAD_REPORT,
  DELETE_BULK_VALIDATION,
  START_BULK_VALIDATION_FAILED,
  START_BULK_VALIDATION_SUCCEEDED,
  LOAD_SINGLE_EMAILS,
  LOAD_SINGLE_EMAILS_SUCCEEDED,
  ADD_INPROCESS,
  BULK_RE_VALIDATION,
  BULK_RE_VALIDATION_FAILED,
  BULK_RE_VALIDATION_SUCCEEDED,
  SWITCH_TAB,
  CLEAR_SINIGLE_EMAILS_DATA,
  GLOBAL_AVAILABLE_CREDITS,
  HIDE_CONFIRMATION,
  SHOW_CONFIRMATION,
  DISPLAY_COMPANY_PROFILE_POPUP,
  BLOCKED_CREDITS,
  LOAD_COMPANY_PROFILE_INFO,
  LOAD_COMPANY_PROFILE_SUCCESS,
  LOAD_COMPANY_PROFILE_ERROR,
} from "../../common/constants";
const initialState = {
  hasMore: true,
  selectedIndex: 0,
  skip: 0,
  limit: 10,
  totalResults: 5,
  uploadedResults: [],
  viewState: "bulk",
  showConfirmation: false,
  showCompanyProfilePopup: true,
  erroredIndex:null,
  globalAvailableCredits: 0,
  blockedcredits: 0,

};
const mapResults = (prevResults, newResults) => {
  if(!prevResults.length){
    return newResults
  }
  newResults.map((newResult, index) => {
    const resp = prevResults.findIndex(prevResult => prevResult.email == newResult.email && prevResult.guid == newResult.guid)
    if(resp > -1){
      // Replacing old obj with new
      prevResults.splice(resp, 1, newResult)
    } else {
      prevResults = [newResult].concat(prevResults).sort((a,b) => new Date(b.time).getTime() - new Date(a.time).getTime())
    }
  })
  return prevResults
}
export const EmailVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISPLAY_COMPANY_PROFILE_POPUP:
      return { ...state, showCompanyProfilePopup: !state.showCompanyProfilePopup }
    case SHOW_CONFIRMATION:
      return {...state, showConfirmation:true, erroredIndex: action.selectedIndex}
    case HIDE_CONFIRMATION:
      return {...state, showConfirmation: false, erroredIndex: null}
    case GLOBAL_AVAILABLE_CREDITS:
      return {...state, 
        globalAvailableCredits: Math.max(0,Number(action.available_credits)),
      }
    case BLOCKED_CREDITS:
      return {
        ...state,
        blockedcredits: Math.max(0,Number(action.blockedcredits)),
      }
    case LOAD_UPLOADED_FILES:
      let uploadedResults = [];
      if (!action.userdata.initial) uploadedResults = state.uploadedResults;
      return { ...state, uploadedResults, loading: true };
    case LOAD_UPLOADED_DETAILS_SUCCEEDED:
      console.log("Load Uploaded Results action : " + JSON.stringify(action));
      let updatedState;
      if (!action.timer) {
        updatedState = state.uploadedResults.concat(
          action.emailverificationinfo.filesResponse
        );
        console.log(
          "updatedState if !action.time : " + JSON.stringify(updatedState)
        );
      } else {
        updatedState = action.emailverificationinfo.filesResponse;
        console.log(
          "updatedState else case action.time : " + JSON.stringify(updatedState)
        );
      }
      //const selectedIndex = action.emailverificationinfo.selectedIndex||0;
      // console.log(
      //   "Updated selected index : " +
      //     JSON.stringify(action.emailverificationinfo)
      // );
      return {
        ...state,
        loading: false,
        uploadedResults: updatedState,
        totalResults: action.totalResults,
        hasMore: action.hasMore,
        skip: action.skip,
        inprocess: action.emailverificationinfo.inprocess,
      };
    case LOAD_SINGLE_EMAILS:
      return { ...state, singleEmailsLoading: true, singleEmailverificationinfo: action.userdata };
    case CLEAR_SINIGLE_EMAILS_DATA:
      return {...state, 
        singleEmailverificationresults:[],
        singleEmailData:{},
      }
    case LOAD_SINGLE_EMAILS_SUCCEEDED:
      return { ...state, 
        singleEmailsLoading: false,
        // singleEmailverificationresults: [...(state.singleEmailverificationresults || []), ...action.results], 
        singleEmailverificationresults: mapResults((state.singleEmailverificationresults || []), action.results), 
        // Handling whether the prev results have any inprogress state
        singleEmailData: {...action.data, inprocess:state.singleEmailData ? state.singleEmailData : action.data.inprocess} 
      };
    case LIST_SELECTED:
      return { ...state, selectedIndex: action.selectedIndex };
    case ADD_INPROCESS:
      //console.log("State ADD_PROCESS : " + JSON.stringify(state));
      //console.log("Action ADD_PROCESS : " + JSON.stringify(action.fileData));
      //const updatedFiles = state.uploadedResults.map((item,index) => index === action.selectedIndex?{...item,status:action.status,status_code:action.status_code}:item);
      const updatedFiles = state.uploadedResults.map((item, i) =>
        i === action.fileData.selectedIndex
          ? {
              ...item,
              status: action.fileData.status,
              status_code: action.fileData.status_code,
            }
          : item
      );
      //console.log("Updated Files : " + JSON.stringify(updatedFiles));
      return { ...state, uploadedResults: updatedFiles };
    case START_BULK_VALIDATION:
      const uploadedResultsProcess = state.uploadedResults.map(
        (value, index) => {
          if (index == action.selectedIndex)
            return { ...value, status_code: -1 };
          else return value;
        }
      );
      let inprocess = state.inprocess + 1;
      //console.log("Uploaded Results After Start : " + JSON.stringify(uploadedResults) );
      return { ...state, inprocess, uploadedResults: uploadedResultsProcess };

    case START_BULK_VALIDATION_FAILED:
      const uploadedResultsFailed = state.uploadedResults.map(
        (value, index) => {
          if (index == action.selectedIndex)
            // Fix: Reverification process state issue (set good,bad,unknown)
            return {
              ...value,
              status_code: -2,
              status: "Ready to Start",
              good: 0,
              bad: 0,
              unknown: 0,
            };
          else return value;
        }
      );
      return { ...state, showConfirmation: false, erroredIndex: null, uploadedResults: uploadedResultsFailed };
    case START_BULK_VALIDATION_SUCCEEDED:
      //console.log("Start Success Action : " + action.selectedIndex);
      const uploadedResultsSucceeded = state.uploadedResults.map(
        (value, index) => {
          if (index == action.selectedIndex)
            return { ...value, status: "In Progress" };
          else return value;
        }
      );
      return { ...state, showConfirmation: false, erroredIndex: null, uploadedResults: uploadedResultsSucceeded };
    // re validation

    case BULK_RE_VALIDATION_FAILED:
      const uploadedRevalidationResultsFailed = state.uploadedResults.map(
        (value, index) => {
          if (index == action.selectedIndex)
            return { ...value, status_code: 1, status: "Completed" };
          else return value;
        }
      );
      return { ...state, uploadedResults: uploadedRevalidationResultsFailed };
    case BULK_RE_VALIDATION_SUCCEEDED:
      //console.log("Start Success Action : " + action.selectedIndex);
      const uploadedReValidationResultsSucceeded = [
        action.emailverificationinfo,
        ...state.uploadedResults,
      ];
      return {
        ...state,
        selectedIndex: Number(state.selectedIndex) + 1,
        uploadedResults: uploadedReValidationResultsSucceeded,
      };

    case DELETE_BULK_VALIDATION:
      //console.log("Files Before Delete : " + JSON.stringify(action));
      //console.log("Files Before State : " + JSON.stringify(state.uploadedResults));
      const uploadedFiles = state.uploadedResults.filter(
        (item, index) => index != action.fileData.selectedIndex
      );
      // console.log(
      //   "Selected Index for Delete : " + action.fileData.selectedIndex
      // );
      // console.log(
      //   "uploadedFiles : " + JSON.stringify(uploadedFiles)
      // );
      return {
        ...state,
        selectedIndex: 0,
        uploadedResults: uploadedFiles,
        totalResults: state.totalResults - 1,
      };
    case DOWNLOAD_REPORT:
      return {
        ...state,
        downloadIndex: action.selectedData.selectedOption,
        downloadTarget: action.selectedData.selectedTarget,
      };

    case SWITCH_TAB:
      console.log("updatedState: " + JSON.stringify(action.updatedState));
      console.log("viewState: " + state.viewState);
      return {
        ...state,
        viewState: action.updateState
          ? action.updateState
          : state.viewState == "bulk"
          ? "single"
          : "bulk",
      };

    default:
      return { ...state };
  }
};

const companyProfileState = {
  showPopup: false, timer: 0, timeLapse:false, isOnlyMins: false, showCountryPopup: false, loading: false, error: null
}

export const CompanyProfileInfoReducer = (state = companyProfileState, action) => {
  switch (action.type) {
    case LOAD_COMPANY_PROFILE_INFO:
      return {
        ...state,
        loading: true
      };
    case LOAD_COMPANY_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload
      };
    case LOAD_COMPANY_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/Containers/EmailValidation/reducer.js